import { render, staticRenderFns } from "./ProductTemplate.vue?vue&type=template&id=ff52b914&"
import script from "./ProductTemplate.vue?vue&type=script&lang=ts&"
export * from "./ProductTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./ProductTemplate.vue?vue&type=style&index=0&id=ff52b914&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports